import React from "react";

/* PayPal wordmark (brand colours) — inline SVG so no external asset is needed */
export function PayPalMark({ className = "h-4" }) {
  return (
    <svg viewBox="0 0 100 26" className={className} aria-label="PayPal" role="img">
      <text x="0" y="20" fontFamily="Verdana, Geneva, sans-serif" fontWeight="700" fontStyle="italic" fontSize="22" fill="#253B80">Pay</text>
      <text x="44" y="20" fontFamily="Verdana, Geneva, sans-serif" fontWeight="700" fontStyle="italic" fontSize="22" fill="#179BD7">Pal</text>
    </svg>
  );
}
